import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { PageView } from '@jg/react-tracking';
import { connect } from 'react-redux';

import StepNavigation from '../../components/StepNavigation';
import CauseCardContainer from '../CauseCardContainer/CauseCardContainer';
import EventCardContainer from '../EventCardContainer/EventCardContainer';
import { ROUTES } from '../../consts';
import { appThunk } from '../../actions';

type YourFundraisingCauseProps = {
  pushToPage: typeof appThunk.pushToPage;
};

export const YourFundraisingCause = ({
  pushToPage,
}: YourFundraisingCauseProps) => {
  const { t } = useTranslation();

  return (
    <PageView
      trackingData={{
        subtype: 'page creation',
        event_value: 'your fundraising cause',
        page_section: 'page creation > your fundraising cause',
      }}
    >
      <Helmet title={t('title.createTeam.yourFundraisingCause')} />
      <main className="jg-space-pbxl jg-space-pbml@md">
        <StepNavigation
          onBackButtonClick={() => pushToPage(ROUTES.EDIT_TEAM_NAME)}
          currentStep={2}
          trackingData={{
            action_name: 'link click',
            subtype: 'button',
            event: 'link click',
            event_value: 'back',
            page_section: 'page creation > your fundraising cause',
          }}
        />
        <h1 className="jg-text--center">
          {t('content.yourfundraisingcause.heading')}
        </h1>
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <p className="jg-text--center jg-text--large">
              {t('content.yourfundraisingcause.subtext')}
            </p>
          </div>
        </div>
        <CauseCardContainer className="jg-space-mvml" />
        <h2 className="jg-h3">
          {t('content.yourfundraisingcause.fundraisingevent')}
        </h2>
        <EventCardContainer className="jg-space-mblg" />
        <div className="jg-tc-button-container">
          <button
            data-qa="your-cause-continue"
            className="jg-btn jg-btn--brand"
            type="button"
            onClick={() => pushToPage(ROUTES.STORY)}
          >
            {t('global.button.continue')}
          </button>
        </div>
      </main>
    </PageView>
  );
};

const mapDispatchToProps = {
  pushToPage: appThunk.pushToPage,
};

export default connect(
  null,
  mapDispatchToProps,
)(YourFundraisingCause);
